import * as React from 'react';

type CallbackFunctionVariadic<T> = (parameter: T) => void;

export interface StepProperties<T extends SharedStepState> {
    onStepCompleted: CallbackFunctionVariadic<T>;
    savedState: T;
}

export interface PrivateStepState {}
export interface SharedStepState {}

export default abstract class Step<
    T extends StepProperties<V>,
    U extends PrivateStepState,
    V extends SharedStepState
> extends React.Component<T, U> {
    constructor(props: any) {
        super(props);
        this.completeStep = this.completeStep.bind(this);
    }

    protected abstract getSharedStepState(): V;

    protected completeStep(): void {
        let stateCopy: V = Object.assign({}, this.getSharedStepState()) as V;
        this.props.onStepCompleted(stateCopy);
    }
}


// WEBPACK FOOTER //
// ./src/webportal/components/wizard/Step.tsx